window.jQuery(function($) {
    "use strict";

    $(document).ready(function() {
        const a = $('.swiper-carousel');
        const b = $('.timeline-swiper');
        const c = $('.nav-mobile');
        const d = $('#cosmet-tab');
        const e = $('.one-carousel');
        const f = $('.swiper-product');
        const g = $('.swiper-remote-posts');

        if (a.length > 0 ) {
            const SwiperCarousel = new window.Swiper(".swiper-carousel", {
                slidesPerView: 5,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                        centeredSlides: true,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    1350: {
                        slidesPerView: 5,
                        spaceBetween: 30,
                    },
                }
            });
        }

        if (b.length > 0 ) {
            const years = ['1931','1932','1935','1947','1956','1972','1989','1996','2009','2012','2016','2017','2018'];
            const TimelineSwiper = new window.Swiper('.timeline-swiper', {
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return (
                            '<span class="' + className + '">' + years[index] + "</span>"
                        );
                    }
                }
            });
        }

        if (c.length > 0 ) {
            $('#nav-mobile-open').on('click', function(event) {
                event.preventDefault();
                c.addClass('active');
            });
            $('.iclose').on('click', function(event) {
                event.preventDefault();
                c.removeClass('active');
            });
        }

        if (d.length > 0 ) {
            $('.btn-tab-prev').on('click', function(event) {
                event.preventDefault();
                $('.nav-link.active').parent('li').prev('li').find('button').trigger('click');
            });
            $('.btn-tab-next').on('click', function(event) {
                event.preventDefault();
                $('.nav-link.active').parent('li').next('li').find('button').trigger('click');
            });
        }

        if (e.length > 0 ) {
            let SwiperOne = new window.Swiper(".one-carousel", {
                slidesPerView: "auto",
                spaceBetween: 0,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: ".swiper-one-next",
                    prevEl: ".swiper-one-prev",
                },
                pagination: {
                    el: ".swiper-one-pagination",
                    clickable: true
                }
            });
            SwiperOne.on('slideChangeTransitionEnd', function () {
                // alert( SwiperOne.realIndex );
                // alert( SwiperOne.previousIndex );
                // alert( SwiperOne.activeIndex );

                //const index_currentSlide = SwiperOne.realIndex;
                const index_nextSlide = SwiperOne.activeIndex;
                const currentSlide = SwiperOne.slides[index_nextSlide];

                //console.log( currentSlide.getElementsByClassName('preview') );
            });

            const NewsModalEl = document.getElementById('newsletterModal');
            const NewsModal   = new window.bootstrap.Modal( NewsModalEl );
            const wpcf7Elm = document.querySelector('.wpcf7');
            wpcf7Elm.addEventListener('wpcf7mailsent', function(evt) {
                NewsModal.show();
            }, false );
            NewsModalEl.addEventListener('hide.bs.modal', function (evt) {
                $('.wpcf7-response-output').html('');
            })
        }

        if (f.length > 0 ) {
            const SwiperProduct = new window.Swiper(".swiper-product", {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            });
        }

        if(g.length > 0) {
            const SwiperPosts = new Swiper('.swiper-remote-posts', {
                slidesPerView: 1,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        pagination: false,
                    }
                }
            });
        }

        $('li.menu-item-has-children').hover(function () {
            // $(this).children("");
        });
    });
});
